// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1hcTJ","head":"ProcedureTableInfo_head__2ATjn"};